import React, { Component } from 'react';
import { object } from 'prop-types';
import { reactEqual } from 'prax';
import { test, init, isString, isArray, removeAtIndex } from 'fpx';

import favicon from 'static/icons/favicon.png';

export class SiteHead extends Component {
  static contextTypes = { history: object.isRequired };

  render() {
    const { children } = this.props;
    const { pathname } = this.context.history.location;
    return (
      <Head>
        <meta charSet="utf-8" />
        <base href="/" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={favicon} />

        <link rel="alternate" hrefLang="x-default" href={pathname} />
        <link rel="alternate" hrefLang="en" href={`${pathname}?lng=en`} />
        <link rel="alternate" hrefLang="ru" href={`${pathname}?lng=ru`} />

        <meta
          name="google-site-verification"
          content="ovlt8hTbLpdEyJZ-AJb-1RKpR777N_fJEtJ5bweEjWQ"
        />

        <title>United Traders</title>
        {/* This is just asking for a race condition; the application may boot up
            before this script has loaded */}
        <script
          src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBUoFot1_Q7_3Wep_Fm1d4FBr6sg_LjyRs"
          async
          defer
        />
        {children}
      </Head>
    );
  }
}

export class Document extends React.Component {
  static childContextTypes = { documentComponent: object };

  getChildContext() {
    return { documentComponent: this };
  }

  constructor() {
    super(...arguments);
    this.state = { headProps: null };
  }

  shouldComponentUpdate() {
    return shouldComponentUpdate.apply(this, arguments);
  }

  render() {
    const {
      state: { headProps },
      props: { children }
    } = this;
    return (
      <html>
        <head {...headProps} />
        <body>
          <div id="root">{children}</div>
          <script src="static/js/bundle.js" />
        </body>
      </html>
    );
  }
}

export class DocumentShim extends React.Component {
  static childContextTypes = { documentComponent: object };

  getChildContext() {
    return { documentComponent: this };
  }

  render() {
    return React.Children.only(this.props.children);
  }

  shouldComponentUpdate() {
    return false; // no props, ignore headProps state
  }
}

export class Head extends React.Component {
  static contextTypes = { documentComponent: object.isRequired, document: object };

  componentWillMount() {
    this.propagateProps();
  }

  componentDidUpdate() {
    this.propagateProps();
  }

  propagateProps() {
    const { documentComponent, document } = this.context;
    const headProps = toHeadProps(this.props);
    documentComponent.setState({ headProps });
    if (document) document.title = getTitle(headProps);
  }

  shouldComponentUpdate() {
    return shouldComponentUpdate.apply(this, arguments);
  }

  render() {
    return null;
  }
}

function shouldComponentUpdate(props, state) {
  return !reactEqual(this.props, props) || !reactEqual(this.state, state);
}

// Some meta tags are unique. Without filtering, earlier tags take precedence in
// the browser, which prevents us from overriding them in nested views.
const uniqueMetaTags = [
  test({ type: 'meta', props: { charSet: isString } }),
  test({ type: 'base' }),
  test({ type: 'link', props: { rel: 'icon' } }),
  test({ type: 'title' })
];

function toHeadProps({ children }) {
  return { children: dedupMeta(flattenArray(children)) };
}

function flattenArray(children) {
  return children.reduce((result, child) => result.concat(child), []);
}

function dedupMeta(children) {
  return uniqueMetaTags.reduce(leaveLastBy, children);
}

function leaveLastBy(list, test) {
  return removeIndices(list, init(findIndices(list, test)));
}

function findIndices(list, test) {
  const out = [];
  for (let i = -1; ++i < list.length; ) if (test(list[i])) out.push(i);
  return out;
}

function removeIndices(list, indices) {
  return indices.reduceRight(removeAtIndex, list);
}

function getTitle({ children }) {
  const element = toArray(children).find(isTitleElement);
  return element ? element.props.children : null;
}

function toArray(value) {
  return isArray(value) ? value : value == null ? [] : [value];
}

const isTitleElement = test({ type: 'title' });



// WEBPACK FOOTER //
// ./src/document.js